import { useEffect } from "react";
import { motion } from "framer-motion";

export const IntroLoader = ({ onDone }) => {
  useEffect(() => {
    const t = setTimeout(onDone, 2400);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <motion.div
      data-testid="intro-loader"
      className="fixed inset-0 z-[100] bg-[#050507] flex flex-col items-center justify-center"
      exit={{ y: "-100%" }}
      transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
    >
      <div className="absolute inset-0 grid-bg opacity-40" aria-hidden="true" />
      <div className="relative">
        <motion.div
          aria-hidden="true"
          className="absolute -inset-12 rounded-full bg-[#6D00FF]/25 blur-[60px]"
          animate={{ opacity: [0.3, 0.9, 0.3] }}
          transition={{ duration: 1.6, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.img
          src="/images/brandzenith-logo.png"
          alt="BrandZenith — Make Your Next Move."
          className="relative w-72 sm:w-80"
          initial={{ opacity: 0, scale: 0.88, filter: "blur(14px)" }}
          animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
          transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
        />
      </div>

      <motion.div
        aria-hidden="true"
        className="mt-10 h-px w-40 bg-gradient-to-r from-[#6D00FF] to-[#C43CFF] origin-left"
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 2, ease: "easeInOut" }}
      />
    </motion.div>
  );
};
